const pad = (value) => String(value).padStart(2, "0");

const toDateInput = (date) =>
  `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;

const createRandomSuffix = () => {
  const array = new Uint8Array(2);

  if (window.crypto?.getRandomValues) {
    window.crypto.getRandomValues(array);
  } else {
    array[0] = Math.floor(Math.random() * 256);
    array[1] = Math.floor(Math.random() * 256);
  }

  return Array.from(array)
    .map((value) => value.toString(36).toUpperCase().padStart(2, "0"))
    .join("");
};

export const createInvoiceNumber = (date = new Date()) => {
  const year = String(date.getFullYear()).slice(-2);
  const month = pad(date.getMonth() + 1);
  const day = pad(date.getDate());
  const hour = pad(date.getHours());
  const minute = pad(date.getMinutes());
  const second = pad(date.getSeconds());

  return `FS-${year}${month}${day}-${hour}${minute}${second}-${createRandomSuffix()}`;
};

export const currencyOptions = [
  {
    code: "USD",
    label: "USD - United States Dollar",
    symbol: "$",
    name: "United States Dollars",
  },
  {
    code: "KES",
    label: "KES - Kenya Shilling",
    symbol: "KES",
    name: "Kenya Shillings",
  },
];

export const getCurrencyOption = (currencyCode) =>
  currencyOptions.find((currency) => currency.code === currencyCode) || currencyOptions[0];

export const companyDetails = {
  name: "FORTRESS SAFE LIMITED",
  address: "Jkia Cargo Center, P.O. Box 43963-00100, Nairobi-Kenya",
  email: "info@fortresssafeltd.com",
  website: "www.fortresssafeltd.com",
  telephone: "+254 755 55 55 95",
  billingFrom: "FORTRESS SAFE LIMITED\nJIA CARGO CENTER, P.O BOX 43963-00100",
};

export const bankDetails = [
  ["ACCOUNT NAME", "FORTRESS SAFE LIMITED"],
  ["USD CURRENT ACCOUNT NO.", "1348279109"],
  ["BANK NAME", "KCB BANK"],
  ["SWIFT CODE", "KCBLKENX"],
  ["BRANCH", "MWINGI"],
  ["BANK CODE", "01"],
  ["BRANCH CODE", "148"],
];

export const defaultTerms = {
  currency: "All amounts are in United States Dollars unless otherwise stated.",
  payment:
    "All storage charges and demurrages shall be paid by the owner as per the invoice received from FORTRESS SAFE LTD.",
};

export const createItemId = () =>
  `item-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;

export const createBlankItem = () => ({
  id: createItemId(),
  description: "",
  rate: "",
  quantity: "",
  unit: "",
});

export const createDefaultInvoice = () => {
  const now = new Date();

  return {
    client: {
      name: "",
      address: "",
      phone: "",
      email: "",
      volumeWeight: "",
      reference: "",
    },
    info: {
      invoiceNumber: createInvoiceNumber(now),
      issueDate: toDateInput(now),
      currencyCode: "USD",
      currencySymbol: "$",
      currencyName: "United States Dollars",
    },
    print: {
      printedAt: "",
    },
    terms: { ...defaultTerms },
    items: [],
  };
};
